import Vue from 'vue'

Vue.use(require('vue-moment'));
Vue.use(require('vue-scrollto'))
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

import { Lang } from 'laravel-vue-lang';
// import Cookies from "js-cookie";
import Cookies from 'vue-cookies';
// Vue.use(Cookies);
// it gets the cookie called `username`
// const username = this.$cookies.get("username");
// console.log(username);
// Register the plugin
// let lang1 = Cookies.set("lang1",'en');
let lang = Cookies.get("lang");
Vue.use(Lang, {
	locale: lang,
	fallback: 'en',
	ignore: {
		lang: ['validation'],
	},
});
// Vue.component('home', () => import('./components/Home/home.vue'));
Vue.component('home', () => import('./components/Home/home-v1.vue'));

Vue.component('Footer', () => import('./components/partials/footer'));
const home = new Vue({
    el: '#home-page-v1'
});
